"use strict";

import React, {Component} from 'react';

export default class TextArea extends Component {
    render() {
        return <textarea {...this.props} />
    }
}


/** WEBPACK FOOTER **
 ** ./~/subschema/src/types/TextArea.jsx
 **/